module.exports = __webpack_public_path__ + "694694c105893eecf2004f3cda55d84e.mp4";